
import { request, success, failure, PROJECT_TEMPLATES_REQUEST } from "./utilities";
import { GetProjectTemplateCategoryListById, GetProjectTemplateBoardDetailsById } from "../api";

export function GetProjectTemplateListById(id) {
    return dispatch => {
        dispatch(request(PROJECT_TEMPLATES_REQUEST.GET_TEMPLATE_BYID_REQUEST))
        GetProjectTemplateCategoryListById(id).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(PROJECT_TEMPLATES_REQUEST.GET_TEMPLATE_BYID_SUCCESS, response.data.data))
                }
                else {
                    dispatch(failure(PROJECT_TEMPLATES_REQUEST.GET_TEMPLATE_BYID_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(PROJECT_TEMPLATES_REQUEST.GET_TEMPLATE_BYID_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    }
}
export function GetProjectTemplateBoardById(id) {
    return dispatch => {
        dispatch(request(PROJECT_TEMPLATES_REQUEST.GET_TEMPLATE_BOARD_REQUEST))
        GetProjectTemplateBoardDetailsById(id).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(PROJECT_TEMPLATES_REQUEST.GET_TEMPLATE_BOARD_SUCCESS, response.data.data))
                }
                else {
                    dispatch(failure(PROJECT_TEMPLATES_REQUEST.GET_TEMPLATE_BOARD_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(PROJECT_TEMPLATES_REQUEST.GET_TEMPLATE_BOARD_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    }
}